import { IUserPersonalData } from '@store/userStore/userStore.type';

const userKeys = {
	all: ['user'],
	statistics: () => [...userKeys.all, 'statistics'],
	platforms: (id?: IUserPersonalData['userId']) => [...userKeys.all, 'platforms', id]
};

export { userKeys };
